<template lang="pug">
  .form-group
    template(v-if="placeholder")
      label {{ placeholder }}
    b-form-input(
      :type="types"
      :class="{ 'is-invalid': dirty == true && error == true, 'is-valid': dirty == true && error == false }"
      :placeholder="placeholder"
      :lazy-formatter="lazyFormatter"
      :disabled="disabled"
      size="sm"
      :value="value"
      @update="handleInput"
      @keypress="onlyNumber"
      @paste.prevent
    )
    template(v-if="title")
      small.text-muted.mr-2 {{ title }}
      //- small.text-muted(v-if="this.$helpers.isAgentLevel()") {{ $t("ui.credit_limit") + " = " + this.$helpers.numberFormat(this.$store.getters.getAccountMemberCreditLimit) }}

</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: "sm"
    },
    lazyFormatter: {
      type: Boolean,
      default: true
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: "0"
    },
    title: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    types: {
      type: String,
      default: "text"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleInput(e) {
      this.$emit("input", e == "" ? "0" : e.replace(/^0+(?=\d)/, ''))
    },
    onlyNumber($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) || [43, 45, 46, 101, 187, 188, 189, 190].includes(keyCode)) { // prevent: "e", "=", ",", "-", "."
        $event.preventDefault();
      }
    }
  }
};
</script>


